import { Link } from 'react-router-dom';
import { getUser } from '../lib/auth';

export function Settings() {
  const user = getUser();
  return (
    <div className="space-y-3">
      <h1 className="text-xl font-bold">Settings</h1>

      <Link to="/settings/services" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Services</div>
          <div className="text-sm text-muted">Add, edit, remove what you offer</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/hours" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Hours & blackouts</div>
          <div className="text-sm text-muted">Weekly schedule + days off</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/stations" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Stations</div>
          <div className="text-sm text-muted">Bays, tubs, workstations · skip if single-station</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/revenue" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Revenue</div>
          <div className="text-sm text-muted">What you've collected · breakdown by payment method</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/invoices" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Receipts &amp; invoices</div>
          <div className="text-sm text-muted">Email receipts, track outstanding invoices</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/email-templates" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Email templates</div>
          <div className="text-sm text-muted">Customize confirmation and update emails sent to customers</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/calendar" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Google Calendar</div>
          <div className="text-sm text-muted">Mirror your bookings to your personal Google Calendar</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <Link to="/settings/account" className="card flex items-center justify-between hover:border-accent">
        <div>
          <div className="font-semibold">Account</div>
          <div className="text-sm text-muted">Change password</div>
        </div>
        <span className="text-muted">›</span>
      </Link>

      <div className="card text-sm text-muted mt-6">
        <div>Signed in as <span className="font-semibold text-text">{user?.display_name}</span></div>
        <div>Role: <span className="text-text/90 capitalize">{user?.role}</span></div>
        <div className="truncate">{user?.email}</div>
      </div>
    </div>
  );
}
